<template>
  <div class="video-section section-content"
       data-aos="fade"
       data-aos-duration="2000">
    <div class="video-container">
      <div class="video-container__placeholder"
           v-if="!playingVideo">
        <div class="video-container__placeholder__overlay">
          <div class="video-container__placeholder__overlay__text">
            <div class="copy">
              <h1 class="video-container__placeholder__overlay__text__headline">
                Reliable<span class="neplus orange-color">&amp;</span>Ready
              </h1>
              <h2 class="video-container__placeholder__overlay__text__subheadline">
                2021 by the Numbers
              </h2>
            </div>
            <a href="https://vimeo.com/687336848" ref="playButton" class="video-container__placeholder__overlay__text__play">
              <div class="video-container__placeholder__overlay__text__play__button">
                <FontAwesomeIcon icon="play" />
              </div>
              <p class="video-container__placeholder__overlay__text__play__text">
                Watch the Video
              </p>
            </a>
          </div>
          <div class="shape shape--home circle circle--home"></div>
        </div>
      </div>
      <!-- animated shapes -->
      <div class="home-video-shapes">
        <div class="shape shape--home squares squares--home">
          <div class="square"></div>
          <div class="square"></div>
        </div>
        <div class="shape shape--home shape--has-bg triangle triangle--home"></div>
        <div class="shape shape--home shape--has-bg dot dot--home"></div>
      </div>
      <!-- end shapes -->
    </div>
  </div>
</template>

<script>

export default {
  name: 'HomeHeroVideo',
  components: { },
  data: function () {
    return {
      playingVideo: false
    };
  },
  mounted () {
    $(this.$refs.playButton).magnificPopup({
      type: 'iframe',
      fixedContentPos: false
    });
    $(window).scroll(function () {
      var scrollPos = $(window).scrollTop();
      if ($(window).width() > 640) {
        $('.doc-1').css({
          transform: 'translateY(-' + scrollPos / 8 + 'px)'
        });
        $('.doc-2').css({
          transform: 'translateY(-' + scrollPos / 15 + 'px)'
        });
        $('.doc-3').css({
          transform: 'translateY(-' + scrollPos / 4 + 'px)'
        });
        $('.doc-4').css({
          transform: 'translateY(-' + scrollPos / 20 + 'px)'
        });
      }
    });
    $(window).resize(function () {
      if ($(window).width() < 1024) {
        $('.doc-1').css({
          transform: 'translateY(0)'
        });
        $('.doc-2').css({
          transform: 'translateY(0)'
        });
        $('.doc-3').css({
          transform: 'translateY(0)'
        });
        $('.doc-4').css({
          transform: 'translateY(0)'
        });
      }
    });
  },
  methods: {
    playVideo: function () {
      this.playingVideo = true;
      this.$refs.player.play();
      /* eslint-disable */
      $(".vimeo-player iframe").css("max-height", "80vh");
      $(".board-chair *[data-aos]").addClass("aos-animate");
      /* eslint-enable */
    },
    onPause: function () {
      this.playingVideo = false;
      /* eslint-disable */
      $(".board-chair *[data-aos]").removeClass("aos-animate");
      /* eslint-enable */
    }
  }
};
</script>
